module.exports = __webpack_public_path__ + "static/note-length-do-b1f85e3d038387d8bee1be2b7feabc56.png";